module.exports = __webpack_public_path__ + "img/bizpic3.9950be59.jpg";